import { render, staticRenderFns } from "./_base-footer.vue?vue&type=template&id=1d202a83&"
import script from "./_base-footer.vue?vue&type=script&lang=js&"
export * from "./_base-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports